import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Actions } from 'src/app/models/actions';
import { Client } from 'src/app/models/client';
import { DataService, SecurityService, WorkflowContextService } from 'src/app/services';
import { ApplicationLogEmailsListComponent } from '../application-log-emails-list/application-log-emails-list.component';

@Component({
    selector: 'wm-log-emails-list',
    templateUrl: './log-emails-list.component.html',
    styleUrl: './log-emails-list.component.css',
    standalone: false
})
export class LogEmailsListComponent implements OnInit, OnDestroy {
  @ViewChild('applicationLogEmailsList', { static: false })
    applicationLogEmailsList: ApplicationLogEmailsListComponent;
  
  clientId: string;
  showJurisdictionSelection = false;
  clientSubscribe: Subscription;
  jurisdictions: Client[] = [];
  canViewLogEmails = false;
 
  constructor(
    private _securitySvc: SecurityService,
    private _context: WorkflowContextService,
    private _dataSvc: DataService,
    private _route: ActivatedRoute
  ) {}

  ngOnInit() {
    this._securitySvc
      .isLoginEntitled(Actions.DO_ANYTHING)
      .subscribe(r => {
        this.canViewLogEmails = r;
      });

    this._route.data.subscribe(data => {
      if (data.globalUsage) {
        this.showJurisdictionSelection = true;

        this.loadJurisdictions();
      } else {
        this.showJurisdictionSelection = false;

        if (this._context.client) {
          this.clientId = this._context.client.id;
        } else {
          this.clientSubscribe = this._context.client$.subscribe(() => {
            this.clientId = this._context.client.id;
          });
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.clientSubscribe) {
      this.clientSubscribe.unsubscribe();
    }
  }

  loadJurisdictions() {
    this._dataSvc.getAdminClients(false).subscribe(jurisdictions => {
      if (jurisdictions) {
        this.jurisdictions = jurisdictions
          .sort((a, b) => (b.name > a.name ? -1 : b.name === a.name ? 0 : 1));
      }
    });
  }
}
